import Swiper from 'swiper';

(function (window, document, $) {
    'use strict';

    $(function () {
        if (!!document.getElementById('home-interests-slider')) {
            new Swiper('#home-interests-slider', {
                slidesPerView: "auto",
                spaceBetween: 20,
                height: 360,
                // slidesOffsetBefore: 50,
                // slidesOffsetAfter: 50,
                centeredSlides: false,
                allowTouchMove: true,
                watchOverflow: false,
                centerInsufficientSlides: true,
                scrollbar: {
                    el: '.swiper-scrollbar'
                },
                mousewheel: true,
                navigation: {
                    prevEl: '.swiper-button-prev',
                    nextEl: '.swiper-button-next'
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<div class="d-inline-block home-interests-pagination-bullet ' + className + '">' + '</div>';
                    },
                },
                breakpoints: {
                    900: {
                        // slidesOffsetBefore: 20,
                        // slidesOffsetAfter: 20,
                        freeMode: true,
                        spaceBetween: 10,

                    }
                }
            });
        }
    })


}(window, document, jQuery));
